var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.08,
    d: "M-652-352H788V672H-652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M465-351V672h-793V-351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    fillRule: "nonzero",
    d: "M10.333 2C5.75 2 2 5.75 2 10.333c0 4.584 3.75 8.334 8.333 8.334 4.584 0 8.334-3.75 8.334-8.334C18.667 5.75 14.917 2 10.333 2m0 15c-3.675 0-6.666-2.992-6.666-6.667s2.991-6.666 6.666-6.666c3.675 0 6.667 2.991 6.667 6.666A6.676 6.676 0 0 1 10.333 17m.417-10.833H9.5v5l4.333 2.666.667-1.083-3.75-2.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHora);
export default __webpack_public_path__ + "static/media/hora.3be056d5bf64f7debe9e2b798768acc8.svg";
export { ForwardRef as ReactComponent };